import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DealerList from "../../features/manageDealers/dealerList";
import { Button } from "@mui/material";

const ManageDealers = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Dealers Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>{" "}
          - Dealers Management
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />

          </div>
          <div className="right_s">
            <Button className="btn btn_primary"><FileDownloadOutlinedIcon /> Export CSV</Button>
            <Button className="btn btn_primary" onClick={() => navigate('/manage-dealers/add')}><AddIcon /> Add Dealer</Button>
          </div>
        </div>
        <DealerList />
      </div>
    </>
  );
};

export default ManageDealers;
